module.exports = __webpack_public_path__ + "static/img/5.317816e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedbacks/5.jpg
// module id = m7bB
// module chunks = 0